export default __webpack_public_path__ + "static/media/pen_icon.44d1ef5c.svg";